import { render, staticRenderFns } from "./Dealers.vue?vue&type=template&id=04002d7e&scoped=true&"
import script from "./Dealers.vue?vue&type=script&lang=js&"
export * from "./Dealers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04002d7e",
  null
  
)

export default component.exports